var NavigationUtil = /** @class */ (function () {
    function NavigationUtil() {
    }
    NavigationUtil.processNavigationPage = function (pageConfiguration, stateService, yOffset) {
        if (yOffset === void 0) { yOffset = 0; }
        pageConfiguration.navigableComponents.map(function (navigableComponent) {
            if (navigableComponent.process(stateService)) {
                navigableComponent.shouldShowComponent = true;
                navigableComponent.yPosition = yOffset;
                yOffset++;
            }
            return navigableComponent;
        });
        return pageConfiguration;
    };
    return NavigationUtil;
}());
export { NavigationUtil };
